const Data = [
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 1,
    "peopleid": 1,
    "name": "Jeremy Cameron",
    "imagename": "Jeremy_Cameron",
    "club": "GWS Giants",
    "salary": "$1,500,000-$1,550,000",
    "salaryCovid": "$1,080,000-$1,116,000",
    "desc": "Signed a heavily back-ended deal which is set to earn the Coleman medallist more than $1.5 million this year - making him the game's biggest earner in 2020. Unfortunately, this year's COVID-19 pay cuts will ensure Cameron misses out on a huge chunk. Terrible timing."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 2,
    "peopleid": 2,
    "name": "Lance Franklin",
    "imagename": "Lance_Franklin",
    "club": "Sydney Swans",
    "salary": "$1,400,000-$1,450,000",
    "salaryCovid": "$1,008,000-$1,044,000",
    "desc": "One of the few contracts that is publicly known, Franklin is due $1.4 million in the third-last season of his nine-year contract. He hasn't won a flag for the Swans but by every metric his free agency acquisition has been a masterstroke, even if the contract lifts to $1.5 million in 2021 before dropping to about $1 million in 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 3,
    "peopleid": 3,
    "name": "Nat Fyfe",
    "imagename": "Nat_Fyfe",
    "club": "Fremantle",
    "salary": "$1,200,000-$1,250,000",
    "salaryCovid": "$864,000-$900,000",
    "desc": "Fyfe deserves every cent he gets and the expectation is that an average contract of $1.1-$1.5 million is heavily-front ended when the AFL's official figures come out early next year. Because who else are the Dockers paying? The dual Brownlow medallist secured a six-year deal when Victorian clubs were lining up to pitch for his services"
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 4,
    "peopleid": 4,
    "name": "Dustin Martin",
    "imagename": "Dustin_Martin",
    "club": "Richmond",
    "salary": "$1,175,000-$1,225,000",
    "salaryCovid": "$846,000-$882,000",
    "desc": "One of the most talked-about contracts in football history - and also one of the most lucrative - runs until the end of 2024. A seven-year, $8.4 million deal was significantly less than what Martin had been offered to join North Melbourne, but it was enough for him to remain a Tiger effectively for life. Will turn 33 in the final year of his deal."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 5,
    "peopleid": 5,
    "name": "Jack Martin",
    "imagename": "Jack_Martin",
    "club": "Carlton",
    "salary": "$1,100,000-$1,150,000",
    "salaryCovid": "$792,000-$828,000",
    "desc": "Martin is footy's unluckiest player after Jeremy Cameron given they are on massively inflated deals for 2020 compared to the average salary of their total contracts, and players are taking a total 30 per cent cut. The average yearly wage in his contract is about $600,000 but the deal was front-ended because the Blues had cap space and wanted to scare off rivals in the pre-season draft."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 6,
    "peopleid": 6,
    "name": "Patrick Dangerfield",
    "imagename": "Patrick_Dangerfield",
    "club": "Geelong",
    "salary": "$1,000,000-$1,050,000",
    "salaryCovid": "$720,000-$756,000",
    "desc": "On track to win his eighth All-Australian guernsey this year and fifth-straight since he joined the Cats at the end of 2015. Has been one of the top few players in the competition over that time, clearly justifying the big money. Locked away until the end of 2024."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 7,
    "peopleid": 7,
    "name": "Jeremy McGovern",
    "imagename": "Jeremy_McGovern",
    "club": "West Coast",
    "salary": "$1,000,000-$1,050,000",
    "salaryCovid": "$720,000-$756,000",
    "desc": "McGovern owns one of footy's richest deals, securing a $6 million deal over five seasons in 2018. But that deal is back-ended so he is believed to be on just over $1 million this year before the contract rises in coming seasons. Like many sides in premiership contention, West Coast has had to back-end some deals to remain in the premiership window."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 8,
    "peopleid": 8,
    "name": "Marcus Bontempelli",
    "imagename": "Marcus_Bontempelli",
    "club": "Western Bulldogs",
    "salary": "$950,000-$1,000,000",
    "salaryCovid": "$684,000-$720,000",
    "desc": "Dogs fans rejoiced when 'the Bont' extended two more years to the remaining year of his contract in late 2018. That takes him through to the end of 2021, and it's near impossible to see any rival prying the Bulldogs skipper away from the Whitten Oval. The Dogs will be looking to have him locked away again by early next season."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 9,
    "peopleid": 9,
    "name": "Lachie Neale",
    "imagename": "Lachie_Neale",
    "club": "Brisbane Lions",
    "salary": "$900,000-$950,000",
    "salaryCovid": "$648,000-$684,000",
    "desc": "Neale won the Lions best-and-fairest in an extraordinary first season with the club, but he has taken his game to an even higher plane this year. He was handed a five-year deal from Brisbane at the end of 2018 and while his average is lower, this year's component is in the mid $950,000-range. The 27-year-old's current deal runs until the end of 2022"
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 10,
    "peopleid": 10,
    "name": "Max Gawn",
    "imagename": "Max_Gawn",
    "club": "Melbourne",
    "salary": "$900,000-$950,000",
    "salaryCovid": "$648,000-$684,000",
    "desc": "Melbourne's highest-paid player deserved the big dough. And he could earn closer to seven figures if he capitalises on some performance incentives as one of the top-two ruckmen in the game. Also one of footy's most marketable stars for endorsement deals."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 11,
    "peopleid": 11,
    "name": "Patrick Cripps",
    "imagename": "Patrick_Cripps",
    "club": "Carlton",
    "salary": "$900,000-$950,000",
    "salaryCovid": "$648,000-$684,000",
    "desc": "Instead of turning the screws and extracting every dollar he could from the Blues in his last contract, Cripps left some on the table so Carlton could build a premiership list. He signed a contract in 2018 that kept him at the club through to 2021. The perfect captain, midfielder and marketable star, there is no danger of him flying the nest."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 12,
    "peopleid": 12,
    "name": "Bradley Hill",
    "imagename": "Bradley_Hill",
    "club": "St Kilda",
    "salary": "$875,000-$925,000",
    "salaryCovid": "$630,000-$666,000",
    "desc": "Hill hasn't set the world on fire in recent weeks but is exactly what St Kilda needed in their phenomenally successful off-season of trades, signing a long-term deal that can earn him as much as $900,000 a season to be the king of the Marvel Stadium wing. Exactly the kind of acquisition the Saints squirrelled away cap space for."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 13,
    "peopleid": 13,
    "name": "Joel Selwood",
    "imagename": "Joel_Selwood",
    "club": "Geelong",
    "salary": "$850,000-$900,000",
    "salaryCovid": "$612,000-$648,000",
    "desc": "Selwood's excellent form was pivotal to Geelong's strong start to 2020. He polled 27 AFL Coaches Association votes in his first six games after an injury-hampered 2019. It shows the skipper remains one of the club's most important players. Well paid since he took over as captain."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 14,
    "peopleid": 14,
    "name": "Isaac Heeney",
    "imagename": "Isaac_Heeney",
    "club": "Sydney Swans",
    "salary": "$825,000-$875,000",
    "salaryCovid": "$594,000-$630,000",
    "desc": "Sydney's newest pin-up boy could have backed up the truck to secure a mega-deal from North Melbourne but still profited from his talent and marketability when he added a further five years to his deal in 2016. With marketing dollars he will take home over $800,000 this season."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 15,
    "peopleid": 15,
    "name": "Rory Sloane",
    "imagename": "Rory_Sloane",
    "club": "Adelaide",
    "salary": "$825,000-$875,000",
    "salaryCovid": "$594,000-$630,000",
    "desc": "The Adelaide captain made a huge sacrifice to remain in Adelaide, shunning free agency and resisting the pull of home when the two-time club champion signed on until 2023. Worth every dollar as a hard-at-it talismanic presence. Sloane could have picked his own club if he decided to return home to Melbourne."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 16,
    "peopleid": 16,
    "name": "Scott Pendlebury",
    "imagename": "Scott_Pendlebury",
    "club": "Collingwood",
    "salary": "$800,000-$850,000",
    "salaryCovid": "$576,000-$612,000",
    "desc": "Pendlebury penned a massive four-year extension in 2015 at the peak of his powers and signed on early this year to extend his deal through to 2021. For many years Pendlebury would have been Collingwood's highest-paid player - if not in the top three - but the expectation is that in his latter years he has taken a pay cut to keep the list together."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 17,
    "peopleid": 17,
    "name": "David Swallow",
    "imagename": "David_Swallow",
    "club": "Gold Coast Suns",
    "salary": "$800,000-$850,000",
    "salaryCovid": "$576,000-$612,000",
    "desc": "The No.1 draft pick stuck fat despite rival interest when Steven May and Tom Lynch departed, signing a five-year contract extension in November 2018. As usual he had suitors back in West Australia but decided he would stick around and build the club from its foundations again."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 18,
    "peopleid": 18,
    "name": "Andrew Gaff",
    "imagename": "Andrew_Gaff",
    "club": "West Coast",
    "salary": "$800,000-$850,000",
    "salaryCovid": "$576,000-$612,000",
    "desc": "Free agent Gaff signed a six-year contract with a trigger clause that allowed him to consider his options after two seasons. That will happen this year and while he was rumoured to be on as much as $1 million a season he accepted less than that to help keep this list together. It was a stunning display of loyalty."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 19,
    "peopleid": 19,
    "name": "Josh Kelly",
    "imagename": "Josh_Kelly",
    "club": "GWS Giants",
    "salary": "$800,000-$850,000",
    "salaryCovid": "$576,000-$612,000",
    "desc": "Was one of the most sought-after players in the game when he signed a landmark deal in 2019 which gave him ultimate flexibility. The six-year contract ensured Kelly would earn top dollar for the entirety of the deal. But an exit clause means Kelly also has the ability to bail next year."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 20,
    "peopleid": 20,
    "name": "Tom Hawkins",
    "imagename": "Tom_Hawkins",
    "club": "Geelong",
    "salary": "$800,000-$850,000",
    "salaryCovid": "$576,000-$612,000",
    "desc": "Signed a bumper five-year contract when Fremantle was hot for a key forward back in 2015. Hawkins has delivered handsomely for the blue and white, leading the club's goal kicking eight times and earning All-Australian honours for the second time last season. Might sign one year deals beyond this year."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 21,
    "peopleid": 21,
    "name": "Jaeger O'۪Meara",
    "imagename": "Jaeger_O_Meara",
    "club": "Hawthorn",
    "salary": "$800,000-$850,000",
    "salaryCovid": "$576,000-$612,000",
    "desc": "The highest-paid Hawk carried a huge load in 2019 after Tom Mitchell went down with a broken leg. The Western Australian has dismissed any doubts over his knee after a nightmare injury run early in his career and signed a four-year extension with Hawthorn last season. Next club captain."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 22,
    "peopleid": 22,
    "name": "Dylan Shiel",
    "imagename": "Dylan_Shiel",
    "club": "Essendon",
    "salary": "$775,000-$825,000",
    "salaryCovid": "$558,000-$594,000",
    "desc": "Carlton flew him up to Noosa on a private jet and, like the Saints, offered him more than $1 million a year. But Shiel took less money to move to Essendon in the belief his chances of on-field success were greater at Tullamarine. In peak form."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 23,
    "peopleid": 23,
    "name": "Elliot Yeo",
    "imagename": "Elliot_Yeo",
    "club": "West Coast",
    "salary": "$775,000-$825,000",
    "salaryCovid": "$558,000-$594,000",
    "desc": "Yeo famously left Brisbane after the Lions lowballed him on a deal and then almost doubled his salary when he accepted close to $800,000 on a five-year extension. The versatile midfielder-tagger-forward has barely missed a game since signing that deal through to 2023. The resume is glittering, with two All-Australian blazers and two best-and-fairest awards with the Eagles."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 24,
    "peopleid": 24,
    "name": "Luke Parker",
    "imagename": "Luke_Parker",
    "club": "Sydney Swans",
    "salary": "$775,000-$825,000",
    "salaryCovid": "$558,000-$594,000",
    "desc": "Sydney locked away Parker as a 23-year-old with the world at his feet, having become the youngest Swan to win the club championship. Out of contract again in 2021, he has rewarded the club with two 500-possession and two 600-possession seasons, always getting on the scoresheet with an average of 18 goals in the past four seasons."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 25,
    "peopleid": 25,
    "name": "Jordan De Goey",
    "imagename": "Jordan_De_Goey",
    "club": "Collingwood",
    "salary": "$775,000-$825,000",
    "salaryCovid": "$558,000-$594,000",
    "desc": "De Goey's two-year contract didn't come cheap and is slightly back-ended. It is understood to start with an eight this year including incentives and a marketing allowance (ASA)."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 26,
    "peopleid": 26,
    "name": "Adam Treloar",
    "imagename": "Adam_Treloar",
    "club": "Collingwood",
    "salary": "$775,000-$825,000",
    "salaryCovid": "$558,000-$594,000",
    "desc": "Like many Pies, including Taylor Adams, he has accepted the security of a longer-term deal but slightly less money as the only way the list can stay together in the premiership window. The Pies knocked back a trade enquiry from Gold Coast last year - Collingwood would have wanted pick one or two in exchange - for Treloar."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 27,
    "peopleid": 27,
    "name": "Travis Boak",
    "imagename": "Travis_Boak",
    "club": "Port Adelaide",
    "salary": "$775,000-$825,000",
    "salaryCovid": "$558,000-$594,000",
    "desc": "Boak has committed to the Power to 2022, having signed a two-year deal earlier this year as the reigning best-and-fairest winner. Port Adelaide pushed back some money from contracts from 2019 through to 2020, with the loyal Boak one of the highest-paid players at the club."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 28,
    "peopleid": 28,
    "name": "Robbie Gray",
    "imagename": "Robbie_Gray",
    "club": "Port Adelaide",
    "salary": "$775,000-$825,000",
    "salaryCovid": "$558,000-$594,000",
    "desc": "Gray has just signed a one-year contract extension through to 2021 and remains one of the game's most dynamic matchwinners. The three-time best-and-fairest winner remains on a great salary for a Power side that had to push some money back into the latter year of deals due to financial pressures in 2019."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 29,
    "peopleid": 29,
    "name": "Tim Kelly",
    "imagename": "Tim_Kelly",
    "club": "West Coast",
    "salary": "$750,000-$800,000",
    "salaryCovid": "$540,000-$576,000",
    "desc": "Kelly got the six-year deal he was asking for and might be able to earn a touch over $800,000 with marketing and bonuses, but couldn't be happier to have got home to be among family after two fabulous seasons at Geelong. For a young bloke playing WAFL footy not too long ago, that deal of around $5 million has set him up for life."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 30,
    "peopleid": 30,
    "name": "Jack Riewoldt",
    "imagename": "Jack_Riewoldt",
    "club": "Richmond",
    "salary": "$750,00-$800,000",
    "salaryCovid": "$540,000-$576,000",
    "desc": "The three-time Coleman medallist is locked away until the end of 2021, having restructured his 2019 contract as well as adding two more years in mid-2018. At the time, Riewoldt said he had taken a pay cut in order to help the club's list management. When his current deal expires, Riewoldt will be about to turn 33."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 31,
    "peopleid": 31,
    "name": "Trent Cotchin",
    "imagename": "Trent_Cotchin",
    "club": "Richmond",
    "salary": "$750,00-$800,000",
    "salaryCovid": "$540,000-$576,000",
    "desc": "Richmond's inspirational skipper was already locked in until the end of the 2020 season when he added two more years in a deal he signed with the club in mid- 2018, just a month after Riewoldt recommitted. The dual premiership captain will be 32 when his current deal expires at the end of 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 32,
    "peopleid": 32,
    "name": "Ben Cunnington",
    "imagename": "Ben_Cunnington",
    "club": "North Melbourne",
    "salary": "$725,000-$775,000",
    "salaryCovid": "$522,000-$558,000",
    "desc": "So often classed as North Melbourne's barometer, the hard inside-mid turned his back on free agency in the middle of last season by locking in until the end of 2022. That two-year extension, signed last July, means he will be 31 in the final year of his current deal."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 33,
    "peopleid": 33,
    "name": "Taylor Walker",
    "imagename": "Taylor_Walker",
    "club": "Adelaide",
    "salary": "$725,000-$775,000",
    "salaryCovid": "$558,000-$594,000",
    "desc": "Signed a contract at the peak of his powers in the 2017 season, having been voted footy's best captain the previous season. Contracted through to the end of 2021 and, while his powers have diminished, he was once one of footy's most dominant forwards and leaders. Has another season to run on his deal."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 34,
    "peopleid": 34,
    "name": "Luke Shuey",
    "imagename": "Luke_Shuey",
    "club": "West Coast",
    "salary": "$725,000-$775,000",
    "salaryCovid": "$522,000-$558,000",
    "desc": "Shuey will go down in West Coast history as a Norm Smith medallist in a premiership side. He signed a four-year extension worth in excess of $3 million in 2017 as the joint vice-captain. He is locked in to 2022 and, having only turned 30 last month, has plenty of great football left, even if he succumbed to a hamstring injury while in hub-life in Queensland."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 35,
    "peopleid": 35,
    "name": "Dyson Heppell",
    "imagename": "Dyson_Heppell",
    "club": "Essendon",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "The Bombers did well to keep him at the height of the drugs saga. He helped hold the club together through that period and again recently re-signed for another two years. Hard to see the midfielder ever leaving."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 36,
    "peopleid": 36,
    "name": "Joe Daniher",
    "imagename": "Joe_Daniher",
    "club": "Essendon",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Probably the most intriguing contract situation in the game. Still keen on a move to Sydney, but how much he will get up north - and subsequently what compensation Essendon would get in return - depends on his comeback from serious groin troubles."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 37,
    "peopleid": 37,
    "name": "Tom Mitchell",
    "imagename": "Tom_Mitchell",
    "club": "Hawthorn",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Signed a two-year extension midway through last year as he rehabilitated from his horrific leg injury. It locked him in to 2023 - giving Mitchell long-term security - but came at a slight discount. Won the Brownlow in 2018 and came from Sydney for a bargain pick - No.14."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 38,
    "peopleid": 38,
    "name": "Ollie Wines",
    "imagename": "Ollie_Wines",
    "club": "Port Adelaide",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Wines was one of footy's hottest properties when he secured a megadeal to remain at Port Adelaide on a four-year contract that runs through to 2020. Since then he has battled shoulder injuries and lost the captaincy. The last few years of this deal get really big really quickly, impeding his trade ambitions. But it was a coup to re-sign him as Victorian teams came hard at the inside mid."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 39,
    "peopleid": 39,
    "name": "Clayton Oliver",
    "imagename": "Clayton_Oliver",
    "club": "Melbourne",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "His price rose quickly, in line with his excellent form over the first four years of his career, making him one of the biggest earners of his age bracket. The hard-nut ball-winner with laser-like hands is already a two-time best-and-fairest winner. Garry Lyon said he was the club's best midfielder in 40 years."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 40,
    "peopleid": 40,
    "name": "Lachie Whitfield",
    "imagename": "Lachie_Whitfield",
    "club": "GWS Giants",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Signed a mega seven-year deal at the Giants which will reward Whitfield handsomely for his long-term loyalty. The Dandenong product is one of the best ball users in the game. St Kilda has chased the No.1 draft pick hard and he is worth the big bucks."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 41,
    "peopleid": 41,
    "name": "Michael Hurley",
    "imagename": "Michael_Hurley",
    "club": "Essendon",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Signed a big deal worth about $800,000 a year to stay when the Western Bulldogs dangled the carrot in 2016. It was a tough situation for the gun defender and he opened up on the emotion of the drugs saga in a teary Footy Show interview. Has been consistent since then and is tied up until 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 42,
    "peopleid": 42,
    "name": "Chad Wingard",
    "imagename": "Chad_Wingard",
    "club": "Hawthorn",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Had work to do over the off-season after a modest first season in brown and gold. But the former Port Adelaide matchwinner has hit his straps this year, re-establishing his reputation as a lethal ball-user. Hawthorn handed over plenty for him - Ryan Burton and pick No. 18."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 43,
    "peopleid": 43,
    "name": "Steven May",
    "imagename": "Steven_May",
    "club": "Melbourne",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Collingwood was keen on May too, but didn't have the high draft pick to satisfy the Suns. So Melbourne opened its wallet for another key defender only one year after landing Jake Lever. Things got off to a rocky start last year but May has been one of Melbourne's best players since he returned to the side."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 44,
    "peopleid": 44,
    "name": "Jake Lever",
    "imagename": "Jake_Lever",
    "club": "Melbourne",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "It was weird how Adelaide handled his departure, given how many Crows players have done exactly the same thing leaving the club in recent years. Regardless, the trade hasn't paid off for Melbourne yet as the defender did his knee and missed a year of footy. Better as the third defender."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 45,
    "peopleid": 45,
    "name": "Jared Polec",
    "imagename": "Jared_Polec",
    "club": "North Melbourne",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Kane Cornes questioned whether \"the footy world has gone mad\" when North Melbourne made Polec an offer he couldn't refuse in late 2018. The five-year deal, believed to be around $700,000 per season, dwarfed Port Adelaide's offer by two years and almost $2 million. His deal runs through until the end of the 2023 season, when he will be 31."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 46,
    "peopleid": 46,
    "name": "Jack Billings",
    "imagename": "Jack_Billings",
    "club": "St Kilda",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Billings waited until he realised his potential as a wingman and half-forward who effortlessly wins possessions and makes use of them with a lethal left foot when he signed a two-year deal through to 2021 in June last year. Essendon had long been a suitor but he never considered leaving and is now in the very elite of wingmen."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 47,
    "peopleid": 47,
    "name": "Jack Darling",
    "imagename": "Jack_Darling",
    "club": "West Coast",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Signed a massive five-year deal in 2019 as a West Coast premiership hero, that deal locking him in as an Eagles player for life. Like many stars he took a long-term deal that allowed the club to keep its list together even though he could have accepted more by moving to the eastern seaboard. How many one-on-one contests has Josh Kennedy benefited from after Darling's hard-running play?"
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 48,
    "peopleid": 48,
    "name": "Mitch Duncan",
    "imagename": "Mitch_Duncan",
    "club": "Geelong",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Western Australian clubs have been trying to lay their hands on the classy wingman for years. He is one of the best kicks at the Cats. Bypassed his 2020 free agency rights when he signed a four-year extension last year, keeping him at the club until 2024."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 49,
    "peopleid": 49,
    "name": "Matt Crouch",
    "imagename": "Matt_Crouch",
    "club": "Adelaide",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Signed a three-year contract extension to remain a Crow coming off an All-Australian season when he was club champion and broke the AFL record for the most possessions in a season at that point. That contract extends to 2021 but he is battling for form after being dropped already this year."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 50,
    "peopleid": 50,
    "name": "Jack Macrae",
    "imagename": "Jack_Macrae",
    "club": "Western Bulldogs",
    "salary": "$700,000-$750,000",
    "salaryCovid": "$504,000-$540,000",
    "desc": "Just over a month after becoming a premiership player, Macrae signed a four-year contract extension taking him through to the end of 2022. Elevated his game to a new level last year, becoming an All-Australian for the first time."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 51,
    "peopleid": 51,
    "name": "Mitch McGovern",
    "imagename": "Mitch_McGovern",
    "club": "Carlton",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "McGovern didn't come cheap when he left a contender in Adelaide to move south instead of going home. And at this stage he hasn't justified the hype, but the Blues always believed he would eventually prove himself as a third tall alongside Charlie Curnow and Harry McKay."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 52,
    "peopleid": 52,
    "name": "Charlie Curnow",
    "imagename": "Charlie_Curnow",
    "club": "Carlton",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Signed on for four years until 2023 midway through 2018 on potential rather than output to that stage, and the injuries haven't abated since then. But every Carlton fan was thrilled to get the signature of a player on a deal worth as much as $3 million if he put up continued strong performances. Still only 77 goals and 58 games under his belt at 22."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 53,
    "peopleid": 53,
    "name": "Ben Brown",
    "imagename": "Ben_Brown",
    "club": "North Melbourne",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "The 27-year-old is awaiting the AFL green light for clubs to restart contract renewals. He had been in line for a new two or three-year deal, reportedly on $800,000 a season, with the Kangaroos before negotiations were put on hold. Brown has been a model of consistency, kicking 63, 61 and 64 goals in his past three seasons, but, like his club, he has struggled for form so far in 2020."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 54,
    "peopleid": 54,
    "name": "Rory Lobb",
    "imagename": "Rory_Lobb",
    "club": "Fremantle",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Lobb has always been well-paid, able to extract around $700,000 a season after signing a bumper contract at GWS after a breakout year as a ruck-forward. The Dockers paid up to get him home because they were determined to bolster their key position stocks, which means he is in the top handful of paid players at Freo."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 55,
    "peopleid": 55,
    "name": "Jarrod Witts",
    "imagename": "Jarrod_Witts",
    "club": "Gold Coast Suns",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "The Suns co-captain signed a five-year extension on a wage between $675,000-$725,000 a season early in 2019, capping a timely move from Collingwood to become a first-rate AFL ruckman. Low-key and rarely handed the plaudits he deserves. First he took the plunge by moving north and then he helped build the culture in his own way."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 56,
    "peopleid": 56,
    "name": "Jack Viney",
    "imagename": "Jack_Viney",
    "club": "Melbourne",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Hasn'۪t been in a rush to sign a new deal this season and it's been a smart decision. Viney's value has gone up after a tough couple of years dealing with some nightmare foot issues. The big challenge for the Demons is fitting all of their hard nuts into the midfield."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 57,
    "peopleid": 57,
    "name": "Dane Rampe",
    "imagename": "Dane_Rampe",
    "club": "Sydney Swans",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Added three seasons to his existing contract in 2018 to lock him in until 2022, Not bad for a former rookie who turned into a 2016 All-Australian. The Dogs twice sniffed around Rampe as a youngster but Sydney eventually took the plunge and have seen him turn into a player who can take almost any player who runs into his area."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 58,
    "peopleid": 58,
    "name": "Dion Prestia",
    "imagename": "Dion_Prestia",
    "club": "Richmond",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Hard to believe Prestia's five-year deal with the Tigers - signed in October 2016 - came as he sought assurances that Damien Hardwick would be retained as coach. Two flags have come since then, as well as a best-and-fairest. He will miss at least the next month - perhaps longer - with injury, but has provided exceptional value for money."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 59,
    "peopleid": 59,
    "name": "Tom McDonald",
    "imagename": "Tom_McDonald",
    "club": "Melbourne",
    "salary": "$675,000-$725,000",
    "salaryCovid": "$486,000-$522,000",
    "desc": "Timed things beautifully when he signed a four-year contract midway through a career-best 2018 season. He's a flexible key position player who had major appeal on the open market. But things haven't quite gone to plan since then, nailing 22 goals in the 20 games since his breakthrough 53-goal haul in 2018."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 60,
    "peopleid": 60,
    "name": "Charlie Cameron",
    "imagename": "Charlie_Cameron",
    "club": "Brisbane Lions",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Brisbane couldn't believe its luck when it coaxed the exciting forward north after the Adelaide Football Club implosion following its 2017 Grand Final. Now the Lions have to keep him. Cameron was on a heavily front-ended deal when he signed for four seasons - until the end of 2021 - on what Crows footy director Mark Ricciuto recently said was \"a very, very good contract.\" Cameron wants an even bigger next deal with speculation he is chasing $800-$850,000."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 61,
    "peopleid": 61,
    "name": "Michael Walters",
    "imagename": "Michael_Walters",
    "club": "Fremantle",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Definitely underpaid and under new management, which is likely to set about renegotiating a contract that goes through to 2022. An All-Australian in 2019, he is a five-time leading goalkicker at the Dockers who regularly wins matches in eye-catching style. Last year's 40.16 year was spectacular."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 62,
    "peopleid": 62,
    "name": "Taylor Adams",
    "imagename": "Taylor_Adams",
    "club": "Collingwood",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "One of many Pies to accept a long-term deal in a selfless manner so the club can remain a contender. He signed a five-year extension last July that locks him in until 2024 and the brilliant flint-hard midfielder also has the leadership skills that could eventually make him a captain in a group that also includes Jeremy Howe and Steele Sidebottom."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 63,
    "peopleid": 63,
    "name": "Zach Merrett",
    "imagename": "Zach_Merrett",
    "club": "Essendon",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Watch this space. Wouldn't be a surprise if clubs with salary cap room throw the kitchen sink at Merrett as a free agent next year. While many clubs already have some hard nut onballers, the big appeal with Merrett is his polish. Great draft pick at No.26."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 64,
    "peopleid": 64,
    "name": "Daniel Talia",
    "imagename": "Daniel_Talia",
    "club": "Adelaide",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Signed a five-year contract extension through to 2021 not long after his 2014 All-Australian season and club championship of that year. Rivals believe he is on even more money given his leverage when he signed, but as the linchpin in defence has been worth his hefty price. Not every side has a full-back that you can guarantee will terrorise the heck out of the opposition's best full-forward."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 65,
    "peopleid": 65,
    "name": "Scott Lycett",
    "imagename": "Scott_Lycett",
    "club": "Port Adelaide",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Lycett couldn't have timed his free agency better, playing only a single game due to injury in 2017 then cashing in after a 25-game premiership season at West Coast. Insiders say he is on more than the $3 million, five-year deal Port Adelaide is said to have clinched, with the Eagles receiving an end-of-first-round compo pick."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 66,
    "peopleid": 66,
    "name": "Christian Petracca",
    "imagename": "Christian_Petracca",
    "club": "Melbourne",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Has shown glimpses of his potential over the years, but this is the year Petracca makes his mark as a star midfielder. Looks fit as a fiddle and is closing the gap on Collingwood game breaker Jordan de Goey as a damaging goalkicker. Next deal could be a doozy."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 67,
    "peopleid": 67,
    "name": "Cale Hooker",
    "imagename": "Cale_Hooker",
    "club": "Essendon",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Another who secured a bumper five-year deal in 2016. At the time, Fremantle was super keen on the Western Australian to fill a missing link in defence. But Hooker remained loyal to the Bombers and is locked away until end of 2021. One more season could round out a very solid career."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 68,
    "peopleid": 68,
    "name": "Jeremy Howe",
    "imagename": "Jeremy_Howe",
    "club": "Collingwood",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "The star defender signed a three-year deal in 2018 that expires next year, with his PCL surgery poor timing given he can earn more than $700,000 with marketing money and incentives if he dominates this year. Went from Melbourne to the club he supported as a kid and now is a brilliant role model and exceptional on-field talent as well as the greatest high-flyer footy has seen."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 69,
    "peopleid": 69,
    "name": "Jade Gresham",
    "imagename": "Jade_Gresham",
    "club": "St Kilda",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Gresham signed a four-year extension at the start of 2019 through to 2023 and the money was well-earned given he has that perfect mix of darting, dangerous small forward and clearance-winning centre square expert. He pledged his future to the Saints at a time when they didn't have a lot of elite talent, but never looked like going elsewhere."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 70,
    "peopleid": 70,
    "name": "Steele Sidebottom",
    "imagename": "Steele_Sidebottom",
    "club": "Collingwood",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Sidebottom had a five-year deal expiring in 2021 that was said to pay him around $3 million but with the uptick in the salary cap would still be in the top bracket. He added an extra season through to 2022 to get more security and would have likely taken a small trim but he is still one of the stars of the compensation and deserves to be handsomely rewarded."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 71,
    "peopleid": 71,
    "name": "Jack Ziebell",
    "imagename": "Jack_Ziebell",
    "club": "North Melbourne",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Was the heir apparent to the Kangaroos' captaincy when the club locked him into a five-year extension - he already had one year left - at the end of 2015. Will be an unrestricted free agent at the end of 2021 when his current deal runs out. But Ziebell has long proclaimed he wants to be a one-club player. Has carried some nagging injuries in recent seasons, but hard to see him playing anywhere else."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 72,
    "peopleid": 72,
    "name": "Jesse Hogan",
    "imagename": "Jesse_Hogan",
    "club": "Fremantle",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Able to earn over $600,000 with strong bonuses including match payments in a strong season after taking a significant pay cut to come home to Perth. Hogan was set to earn as much as $900,000 at Melbourne with predictions he was footy's next great forward, but instead took a deal worth about $2 million over three seasons. Finally back in a good head space after mental health issues."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 73,
    "peopleid": 73,
    "name": "Brad Crouch",
    "imagename": "Brad_Crouch",
    "club": "Adelaide",
    "salary": "$650,000-$700,000",
    "salaryCovid": "$468,000-$504,000",
    "desc": "Signed a four-year deal in August 2016 after strong form as a tough ball-winning midfielder despite interest from Victoria. Comes out of contract as a free agent this year with polarising views about whether he's an elite midfielder worth $900,000 a year or just a strong accumulator who doesn't hurt the opposition enough."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 74,
    "peopleid": 74,
    "name": "Darcy Moore",
    "imagename": "Darcy_Moore",
    "club": "Collingwood",
    "salary": "$625,000-$675,000",
    "salaryCovid": "$450,000-$486,000",
    "desc": "Moore could be footy's best defender by year's end and is keen to stay at the club where his father became famous. He has missed chances to sign megabucks deals given unfortunate injuries and the Pies declining to negotiate an early contract extension after a breakout second season. But he is still well paid and, at only 24, has time to set himself up for life after football."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 75,
    "peopleid": 75,
    "name": "Lachie Hunter",
    "imagename": "Lachie_Hunter",
    "club": "Western Bulldogs",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "It's already been an expensive year for Hunter with his drink-driving incident early in the year alongside the COVID-19 reductions applied to his current deal. He signed a five-year contract just over a month from claiming the Charlie Sutton Medal in 2018. He had already signalled his intention of remaining a Bulldog for life in his acceptance speech. The deal takes him through to the end of the 2024 season."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 76,
    "peopleid": 76,
    "name": "Jake Carlisle",
    "imagename": "Jake_Carlisle",
    "club": "St Kilda",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Carlisle signed on a bumper deal when no one wanted to come to St Kilda, and while he was immediately plunged into a drugs controversy he was able to tick off the final year of his contract with a games-based trigger late last year. It means he is still on an excellent wage this year amid some speculation the club would have brokered a trade last off-season."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 77,
    "peopleid": 77,
    "name": "Josh Kennedy",
    "imagename": "Josh_Kennedy",
    "club": "Sydney Swans",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Kennedy signed a significant three-year deal in late 2016 as one of the game's most relentless and durable footballers. Has now had that deal extended through to 2021 after Sydney pulled off one of footy's most remarkable recruiting heists. He turned himself from a fringe Hawk into a player who peeled off top-three best-and-fairest results year after year after year."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 78,
    "peopleid": 78,
    "name": "James Sicily",
    "imagename": "James_Sicily",
    "club": "Hawthorn",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Looks cheap for one of the most damaging playmakers in the competition. Sicily was a strong contender for All-Australian selection in each of the past two seasons and is a weapon using the ball off the back flank. The gun interceptor has matured in recent seasons and will remain at the club until the end of 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 79,
    "peopleid": 79,
    "name": "Sam Docherty",
    "imagename": "Sam_Docherty",
    "club": "Carlton",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The Blues co-captain added an extra season to his deal in 2019 having shown he is among footy's best defenders before having to rehabilitate a ruptured ACL twice. One of footy's best thinkers and media performers, you get the feeling he will go straight into coaching when his career finishes, having started that process by helping from the sidelines as he worked on his return to AFL."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 80,
    "peopleid": 80,
    "name": "Phil Davis",
    "imagename": "Phil_Davis",
    "club": "GWS Giants",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Probably has one more season in him after signing his latest three-year deal in 2018. Davis, 29, has earned good money at GWS since departing Adelaide on a godfather deal. Has been a key leader in a defensive role since the Giants' first years."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 81,
    "peopleid": 81,
    "name": "Peter Wright",
    "imagename": "Peter_Wright",
    "club": "Gold Coast Suns",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Wright signed a lucrative extension through to 2022 last year but is yet to match the hype, with \"Two Metre Peter\" out of the team this year after 21 goals in 17 games last season. His salary is reflective of the difficulty in finding 200cm key-forward rucks in the AFL. With Jarrod Witts thriving with big game time as a ruckman and Sam Day the current foil to Ben King, Wright hasn't cracked it for a senior game yet this year."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 82,
    "peopleid": 82,
    "name": "Brandon Ellis",
    "imagename": "Brandon_Ellis",
    "club": "Gold Coast Suns",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The Richmond premiership player signed a five-season deal believed to be just over $600,000 a season last year to add quality ball use and hard run to a young Suns' side. So far it's exactly what he has done even if he has been solid rather than eye-catching. Ellis made an easy call to move on from the Tigers to shore up his family's financial future."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 83,
    "peopleid": 83,
    "name": "Isaac Smith",
    "imagename": "Isaac_Smith",
    "club": "Hawthorn",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The Bulldogs unsuccessfully chased Smith last year in a bid to add some more cream to a stacked midfield. He is a restricted free agent at Hawthorn and will surely attract more offers at season's end as the club weighs up a move to top-up again or chase more top-end talent in the draft."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 84,
    "peopleid": 84,
    "name": "Dayne Zorko",
    "imagename": "Dayne_Zorko",
    "club": "Brisbane Lions",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "A contract extension signed by the Brisbane skipper in early 2019 locked him in until the end of 2021. That upped the ante after he had previously signed a $2 million five-year deal, which was upgraded after four successive best-and-fairest awards. The Lions pay many of their stars with an excellent base component with bonus clauses."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 85,
    "peopleid": 85,
    "name": "Tom Papley",
    "imagename": "Tom_Papley",
    "club": "Sydney Swans",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The Gippsland boy is tied to the Swans all the way through to 2023, having signed a deal in 2018 that included a trigger clause he quickly ticked off. It means he is well paid for his services after wanting to be traded to Carlton last year. So he should be, as one of footy's best-performed small forwards. Still weighing his future."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 86,
    "peopleid": 86,
    "name": "Angus Brayshaw",
    "imagename": "Angus_Brayshaw",
    "club": "Melbourne",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "North Melbourne went extremely hard at Brayshaw, making Melbourne plump up its offer in a bid to keep the tough nut ball-winner. He finished third in the Brownlow Medal in 2018 but he had a difficult year last season, playing outside the centre square. Contracted until the end of 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 87,
    "peopleid": 87,
    "name": "Dan Hannebery",
    "imagename": "Dan_Hannebery",
    "club": "St Kilda",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "St Kilda has long been aggrieved at reports on the scope of Hannebery's contract, a four-year deal with triggers for a fifth season. Instead of earning him up to $800,000 a season, his deal is less than $700,000, still a rich reward but fairer compensation for a player who represented a risk given his groin and soft-tissue concerns of recent years."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 88,
    "peopleid": 88,
    "name": "Callum Mills",
    "imagename": "Callum_Mills",
    "club": "Sydney Swans",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Just months after locking away Isaac Heeney in early 2017, the Swans secured a five-year contract extension for Mills, fresh off his Rising Star win. The massive show of faith came after Mills' exceptional debut season. The deal locks him into the club he barracked for as a kid until the end of 2023, when he will still only be 26 years of age."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 89,
    "peopleid": 89,
    "name": "Jack Gunston",
    "imagename": "Jack_Gunston",
    "club": "Hawthorn",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The Hawks moved early to sign Gunston in late 2018 well before he was due to come out in 2019. That's how the Hawks operate with their most important players to ensure they aren't vulnerable to a poaching raid. It's smart and the improved deal rewarded Gunston for his continued excellent service at both ends of the ground."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 90,
    "peopleid": 90,
    "name": "Nic Naitanui",
    "imagename": "Nic_Naitanui",
    "club": "West Coast",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "At times Naitanui has been one of footy's highest-earning players. And make no mistake, he is effectively the king of Perth with his extraordinary reach as an ambassador, marketing force and A-Grade celebrity in a state where footy couldn't be bigger. Instead of a seven-figure salary, he took a pay cut when he re-signed only days before a return from a knee reconstruction in 2019 that locks him away until 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 91,
    "peopleid": 91,
    "name": "Stephen Coniglio",
    "imagename": "Stephen_Coniglio",
    "club": "GWS Giants",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "The new GWS captain has taken a back-ended deal like many of his teammates to keep the list together, happy to sign on for a seven-year deal despite coming perilously close to moving to Carlton. The average is much higher but while the Giants are in the sweet spot everyone is sacrificing to keep the list in shape."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 92,
    "peopleid": 92,
    "name": "Jason Johannisen",
    "imagename": "Jason_Johannisen",
    "club": "Western Bulldogs",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Norm Smith medallist Jason Johannisen weighed up several lucrative offers from rival clubs in mid-2017 before locking into a five-year-deal with the Bulldogs, believed to be worth around $600,000 per season. The deal locked him into the club until the end of 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 93,
    "peopleid": 93,
    "name": "Dougal Howard",
    "imagename": "Dougal_Howard",
    "club": "St Kilda",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Howard signed a five-year deal with the Saints on $600,000 a season after the swingman fell out of favour at Port Adelaide. While he hasn't set the world on fire yet at the Saints, he has been a solid defensive presence."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 94,
    "peopleid": 94,
    "name": "Easton Wood",
    "imagename": "Easton_Wood",
    "club": "Western Bulldogs",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "One of footy's best interceptors at his best, he signed his deal not long after the Dogs' premiership heroics as the captain and attacking force off half-back. Wood has had injury worries of late but signed his deal at the perfect time to maximise his worth and handed the captaincy over to Marcus Bontempelli with the club in excellent shape."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 95,
    "peopleid": 95,
    "name": "Jake Lloyd",
    "imagename": "Jake_Lloyd",
    "club": "Sydney Swans",
    "salary": "$600,000-$650,000",
    "salaryCovid": "$432,000-$468,000",
    "desc": "Lloyd signed a four-year deal off the back of a season that had him in the All-Australian 40 and chased hard by Gold Coast keen on his bounce from defence and long precise kicking. That September 2018 deal has him locked away until 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 96,
    "peopleid": 96,
    "name": "Charlie Dixon",
    "imagename": "Charlie_Dixon",
    "club": "Port Adelaide",
    "salary": "$575,000-$625,000",
    "salaryCovid": "$414,000-$450,000",
    "desc": "The ex-Sun was able to use Adelaide's interest to secure a five-year deal on $600,000 when he arrived at Port Adelaide on a contract that expires this year. He will get well paid once again. The big key forwards get the big dollars and Dixon is no different."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 97,
    "peopleid": 97,
    "name": "Hamish Hartlett",
    "imagename": "Hamish_Hartlett",
    "club": "Port Adelaide",
    "salary": "$575,000-$625,000",
    "salaryCovid": "$414,000-$450,000",
    "desc": "Hartlett had maximum leverage when he signed a five-year deal with the Power in 2015 as clubs including Richmond and North Melbourne showed interest. Hasn't reached the heights he might have wanted but has few regrets even as he passed up the Tigers' interest. Out of contract in 2021."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 98,
    "peopleid": 98,
    "name": "Tom Rockliff",
    "imagename": "Tom_Rockliff",
    "club": "Port Adelaide",
    "salary": "$575,000-$625,000",
    "salaryCovid": "$414,000-$450,000",
    "desc": "The Power snapped up out ex-Brisbane captain Rockliff as part of a late 2017 recruiting spree and paid a significant price for the free agent. The deal is believed to be just on $575,000 a season over a four-year deal for the clearance king, but the club's welter of young midfielders are making life hard. Has been dropped this year."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 99,
    "peopleid": 99,
    "name": "Tom Jonas",
    "imagename": "Tom_Jonas",
    "club": "Port Adelaide",
    "salary": "$575,000-$625,000",
    "salaryCovid": "$414,000-$450,000",
    "desc": "Jonas has graduated from one-time rookie to the sole captain of Port Adelaide after sharing the role with Ollie Wines last year. The 29-year-old defender recommitted to the club at the end of the 2018 season when he still had one year remaining. His current contract runs through to the end of 2022."
  },
  {
    "status": "",
    "perc": {
        "underrated": 0,
        "overrated": 0,
        "agree": 0
    },
    "id": 100,
    "peopleid": 100,
    "name": "Brodie Grundy",
    "imagename": "Brodie_Grundy",
    "club": "Collingwood",
    "salary": "$550,000-$625,000",
    "salaryCovid": "$414,000-$450,000",
    "desc": "The AFL's prototypical ruckman drove a hard bargain and even threatened to head home but eventually got his seven-year contract extension. He secured it for a tick under $7 million but, like Tom Lynch, will make just under $600,000 this season before his contract ramps up in 2021."
  }
]

export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js